export default {
  data() {
    return {};
  },
  props: {
    quote: String,
    name: String,
    school: String,
  },
};



// WEBPACK FOOTER //
// ./src/app/features/authentication/components/teacherQuotes/teacherQuotes.container.js